"use client";

import Link from "next/link";
import { Minus, Plus, XLogo } from "@phosphor-icons/react";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@shared/ui/accordion";
import { cn } from "@shared/ui/utils";

import { Section } from "../section";

const infos = [
  {
    value: "value1",
    question: "When should I expect to get access to Tenki?",
    answer: "We plan to officially launch Tenki at the beginning of Q2 2025. Stay tuned for updates!",
  },
  {
    value: "value2",
    question: "Who is Tenki designed for?",
    answer: (
      <>
        <span>
          Whether you’re a DevOps engineer, a startup founder, a solo developer, or part of a growing team, our runners
          and platform capabilities are built to fit your needs. Join the waitlist to secure your spot and follow us
          on{" "}
        </span>
        <Link
          href="https://x.com/tenkicloud"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X/Twitter"
          className="inline-flex translate-y-[3px] text-white"
        >
          <XLogo size={16} />
        </Link>
        <span> for more updates on Tenki.</span>
      </>
    ),
  },
  {
    value: "value3",
    question: "What features will be available with the release of Tenki?",
    answer:
      "At launch, we’ll provide runners along with workspace and project management features, allowing full control over member settings. More features will be introduced post-launch, guided by our roadmap and shaped by community input!",
  },
  {
    value: "value4",
    question: "What pricing models will be offered?",
    answer:
      "We plan to implement a transparent, pay-as-you-go pricing model. To facilitate onboarding and gather feedback, users will receive free credits at the start of each month. Additionally, we intend to introduce committed discounts after launch.",
  },
  {
    value: "value5",
    question: "How can I stay updated on the latest news?",
    answer: (
      <>
        <span>Follow us on </span>
        <Link
          href="https://x.com/tenkicloud"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X/Twitter"
          className="inline-flex translate-y-[3px] text-white"
        >
          <XLogo size={16} />
        </Link>
        <span> for exclusive updates, feature announcements, and early access perks.</span>
      </>
    ),
  },
];

export const QAndA = () => {
  return (
    <Section
      id="q-and-a"
      title="Questions and answers"
      contentClass="md:grid-cols-1"
      description={
        <>
          Have a question we haven’t answered? Reach out to{" "}
          <Link
            href="mailto:hello@tenki.cloud"
            className="text-cta-link-rest hover:text-cta-link-hovered underline transition-colors duration-300"
          >
            hello@tenki.cloud
          </Link>
        </>
      }
    >
      <Accordion type="multiple">
        {infos.map((info, index) => (
          <AccordionItem
            key={`q-and-a-${index}`}
            value={info.value}
            className={cn("border-b-[0.5px]", index === 0 && "border-t-[0.5px]")}
          >
            <AccordionTrigger
              className="group relative items-start py-6 text-lg leading-7 font-normal [&[data-state=open]>svg]:rotate-0"
              Icon={
                <div className="text-cta-ghost-default-foreground relative top-1 size-5 shrink-0">
                  <Plus
                    className={cn(
                      `absolute opacity-0 transition-all duration-233 group-[&[data-state='closed']]:rotate-180 group-[&[data-state='closed']]:opacity-100`,
                    )}
                  />
                  <Minus
                    className={cn(
                      `absolute opacity-0 transition-all duration-200 group-[&[data-state='closed']]:rotate-180 group-[&[data-state='open']]:opacity-100`,
                    )}
                  />
                </div>
              }
            >
              {info.question}
            </AccordionTrigger>
            <AccordionContent className="text-md text-static-secondary text-wrap whitespace-break-spaces">
              {info.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Section>
  );
};
